import React from "react";
import { GetClientWiseOCRReportListType, InvoiceClientData } from "../../../../redux/listing/listingTypes";
import { TableHeadersType } from "../../../../constant/tableHeadersConstants/tableHeadersType";
import { CLIENT_WISE_INNER_HEADERS } from "../../../../constant/tableHeadersConstants/UserAndClientWiseOCRReportConst";
import { CircularAvatar } from "../../../commons";

type AppProps = {
  data: GetClientWiseOCRReportListType[] | [];
  tableHeader: TableHeadersType[] | [];
  setData: React.Dispatch<
    React.SetStateAction<[] | GetClientWiseOCRReportListType[]>
  >;
};
const SingleClientWiseTableData = ({
  data,
  tableHeader,
  setData,
}: AppProps) => {
  return (
    <>
      {data?.length > 0 &&
        data.map(
          (itemData: GetClientWiseOCRReportListType, outerIndex: number) =>
            itemData?.user_list?.length > 0 &&
            itemData.user_list.map((insideData: InvoiceClientData, innerIndex: number) => {
              return (
                <tr key={`row-${outerIndex}-${innerIndex}`}>
                  {CLIENT_WISE_INNER_HEADERS?.map(
                    (header: TableHeadersType, i: number) => {
                      if (header?.value === "user") {
                        return (
                          <td key={i}>
                            <div>
                              <div
                                className="d-flex justify-content-sm-start"
                                style={{ gap: "10px" }}
                              >
                                {
                                  <CircularAvatar
                                    name={
                                      insideData?.created_by?.first_name +
                                      " " +
                                      insideData?.created_by?.last_name
                                    }
                                    image={
                                      insideData?.created_by?.profile_pic?.file_url
                                        ? insideData?.created_by?.profile_pic?.file_url
                                        : ""
                                    }
                                  />
                                }
                                <div>
                                  <span>
                                    {insideData?.created_by?.first_name}{" "}
                                    {insideData?.created_by?.last_name}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </td>
                        );
                      } else if (header?.value === "expenses") {
                        return <td key={i}>{insideData?.expense_count}</td>;
                      } else if (header?.value === "sales") {
                        return <td key={i}>{insideData?.sales_count}</td>;
                      } else if (header?.value === "total") {
                        return <td key={i}>{insideData?.total_count}</td>;
                      }
                    }
                  )}
                </tr>
              );
            })
        )}
    </>
  );
};

export default SingleClientWiseTableData;
